import { AfterViewInit, Component, ElementRef, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { Task } from '../_types/task';
import { User } from '../../users/_types/user';
import { TasksService } from '../_services/tasks.service';
import { UsersService } from '../../users/_services/users.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { CasesService } from '../../cases/_services/cases.service';
import { CasesNotesService } from '../../cases/_services/cases-notes.service';
import { Case } from '../../cases/_types/case';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { LoginService } from '../../login/login.service';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { TaskComment } from '../_types/task-comment';
import {  TasksCommentsService } from '../_services/tasks-comments.service';
import { NotificationsService } from '../../notifications/_services/notifications.service';
import { LocalStorageService } from 'angular-web-storage';
import { StringUtilsService } from 'src/app/core/services/string-utils.service';

@Component({
    selector: 'app-tasks-detail',
    templateUrl: './tasks-detail.component.html',
    styleUrls: ['./tasks-detail.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TasksDetailComponent implements AfterViewInit {
  public taskFormGroup!: RxFormGroup;

  public task: Task = new Task();
  public users: User[] = [];
  public case!: Case;

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public comments: TaskComment[] = [];
  public commentModal: boolean = false;
  public newComment: TaskComment = new TaskComment();
  @ViewChildren('autoGrowTextarea') autoGrowTextareas!: QueryList<ElementRef<HTMLTextAreaElement>>;
  constructor(
    private tasksService: TasksService,
    private usersService: UsersService,
    private casesService: CasesService,
    private casesNotesService: CasesNotesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private topbarService: TopbarService,
    private loginService: LoginService,
    private taskCommentsService: TasksCommentsService,
    private notificationsService: NotificationsService,
        private storage: LocalStorageService,
        public stringUtils: StringUtilsService
  ) {
    this.taskFormGroup = this.formBuilder.formGroup<Task>(this.task) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalles de tarea");
    this.topbarService.addBreadcrumb("Tareas", "/tasks");

    let id = this.route.snapshot.params['guid'];
    if (id != null && id != '0') {
      await this.loadTask(id);
      await this.loadTaskComments();
    }
    this.allowWrite = this.loginService.hasPermission("TASKS.WRITE");
    this.allowDelete = this.loginService.hasPermission("TASKS.DELETE");
    this.scheduleResizeTextareas();
    this.loadUsers(); //cargamos los usuarios para el select de asignación tras tener la tarea cargada, para que si tiene un usuario asignado que no esté en los 100 primeros resultados, se le añada a la lista
  }

  ngAfterViewInit(): void {
    this.autoGrowTextareas.changes.subscribe(() => this.scheduleResizeTextareas());
    this.scheduleResizeTextareas();
  }

  async loadTask(id: string) {
    this.task = await firstValueFrom(this.tasksService.get(id, { include: ['user'] }));

    //si tiene expediente asociado, lo cargamos
    if (this.task.caseNoteId != null) {
      let caseNote = await firstValueFrom(this.casesNotesService.get(this.task.caseNoteId));
      this.case = await firstValueFrom(this.casesService.get(caseNote.caseId));
    }

    this.taskFormGroup.patchValue(this.task);

    //si tiene una notificación asociada, la marcamos como leída
    var user = this.storage.get('user');
    let params: IParamsCollection = {
    }
    let filters: any = {
      sourceId: new Filter(FilterOperation.equals, "sourceId", '', id),
      userId: new Filter(FilterOperation.equals, "userId", '', user.id),
      source: new Filter(FilterOperation.equals, "source", '', "Task"),
      web: new Filter(FilterOperation.equals, "web", '', true),
      push: new Filter(FilterOperation.equals, "push", '', false)
    };
    
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.notificationsService.all(params));
    var notifications = response.data;
    for(let notification of notifications){
      await firstValueFrom(this.notificationsService.markAsReaded(notification));
    }

    this.scheduleResizeTextareas();
  }

  public scheduleResizeTextareas(): void {
    setTimeout(() => this.resizeAllTextareas(), 0);
  }

  private resizeAllTextareas(maxHeight: number = 500): void {
    if (!this.autoGrowTextareas) {
      return;
    }

    this.autoGrowTextareas.forEach((textareaRef) => {
      this.stringUtils.ResizeTextareaElement(textareaRef.nativeElement, maxHeight);
    });
  }

  async loadTaskComments(){
    let params: IParamsCollection = {
      include: ['createdByUser'],
      sort: ['date']
    }
    let filters: any = {
      taskId: new Filter(FilterOperation.equals, "taskId", '', this.task.id)
    };
    
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.taskCommentsService.all(params));
    this.comments = response.data;
  }
  
  async loadUsers(event?: any) {
       let text = "";
      if (event != null) text = event.filter; 
      let filters = {
        name: new Filter(FilterOperation.contains, 'name', '', text)  ,
        isWorker: new Filter(FilterOperation.equals, 'isWorker', '', false)   
      };
      let params: IParamsCollection = {
        page: { size: 100, number: 1 },
        sort: ['name'],
        filter: FilterBuilder.fromObject(filters).build()
      };

    let response = await firstValueFrom(this.usersService.all(params));
    this.users = response.data;
    if(text == "" && this.task.userId != null && this.users.findIndex(u => u.id == this.task.userId) == -1){
      //por si no lo ha encontrado en los 100 primeros resultados, se lo añadimos
      this.users.unshift(this.task.user);
    }
  }

  viewCaseNote() {
    this.router.navigate(['cases', this.task.caseNote.caseId]);
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.taskFormGroup);
    if (valid) {
      this.task = Object.assign(this.task, this.taskFormGroup.value);

      let taskItem = await firstValueFrom(this.tasksService.save(this.task));
      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Tarea guardada correctamente." });
      this.router.navigate(['tasks']);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la tarea?",
      header: "Eliminar tarea",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.tasksService.delete(this.task.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Tarea eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  cancel() {
    this.router.navigate(['tasks']);
  }

  addComment(){
    this.newComment = new TaskComment();
    this.newComment.taskId = this.task.id as string;
    this.newComment.date  = new Date();
    this.commentModal = true;

  }
  cancelCommentModal(){
    this.commentModal = false;
  }

  async saveComment(){
    if(this.newComment.description == null || this.newComment.description.trim() == ""){
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "El comentario no puede estar vacío." });
      return;
    }
      let comment = await firstValueFrom(this.taskCommentsService.save(this.newComment));
      this.commentModal = false;
      this.loadTaskComments();
  }
}
